import { useEffect } from "react";
import { OrderStatus } from "~graphql/sdk";
import { trackPurchase, trackPurchaseFB, trackTransactionReady } from "~lib";
import { useFacebookPixelScript } from "~features/tracking";
import { useOrderContext } from "./OrderContext";
import { useOrganization } from "~hooks";

/**
 * Custom hook to handle analytics tracking and Facebook Pixel integration
 * for checkout flows. Automatically fires tracking events when orders are completed.
 */
export const useAnalyticsAndTracking = () => {
  const { order } = useOrderContext();
  const { organization } = useOrganization();

  // Load Facebook Pixel script
  useFacebookPixelScript(
    order?.event?.pixelId ?? organization?.marketing?.pixelId ?? ""
  );

  // Analytics tracking on order completion
  useEffect(() => {
    if (
      order &&
      [OrderStatus.Paid, OrderStatus.Completed].includes(order?.status) &&
      order.total > 0
    ) {
      const context = {
        currency: organization.currency,
      };

      trackTransactionReady(order);
      trackPurchase(order, context);
      trackPurchaseFB(
        order,
        organization,
        order?.event?.pixelId ?? organization?.marketing?.pixelId
      );
    }
  }, [order?.status, order, organization]);
};
